import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };
  
  getProcessData = (params) => {
    return AxiosService.Get(`api/cam/srm/process-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  getProcessDropdown = (params) => {
     return AxiosService.Get(`api/cam/srm/limits-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  EditFormData = (obj) => {
    return AxiosService.Put(`api/cam/srm/edit-process-parameter/`,obj, {
      ...this.getHeaders(),
    });
  };
}
